import classnames from 'classnames';

type NavBarProps = {
  className?: string;
  children?: React.ReactNode;
  isSticky?: boolean;
};
const stickyClasses = 'sticky top-0';
const notStickyClasses = 'relative';

const NavBar = ({ className, children, isSticky }: NavBarProps): JSX.Element => {
  return (
    <div
      className={classnames(
        'z-20 flex flex-row items-center bg-secondary-lighter dark:bg-secondary-dark',
        isSticky && stickyClasses,
        !isSticky && notStickyClasses,
        className
      )}
      style={{ padding: '6px 16px', minHeight: 48 }}
    >
      {children}
    </div>
  );
};

export default NavBar;
